import { ModelSagres } from "@/types/model-sagres";

export class QntdRespostas extends ModelSagres {
    respostasBot: number
    respostasIA: number
    respostasAuditor: number

    constructor(obj?: any) {
        super()
        if (obj) {
            if (obj.respostasBot) this.respostasBot = obj.respostasBot
            if (obj.respostasIA) this.respostasIA = obj.respostasIA
            if (obj.respostasAuditor) this.respostasAuditor = obj.respostasAuditor
        }
    }
}
